import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'relay-fetch.services.error-flags.title',
		defaultMessage: "Something's gone wrong",
		description: 'Flag title. Informs a user of an unauthenticated error.',
	},
	description: {
		id: 'relay-fetch.services.error-flags.description',
		defaultMessage: "Looks like you've been signed out. Try logging in again. ",
		description: 'Flag description. Informs a user of an unauthenticated error.',
	},
	login: {
		id: 'relay-fetch.services.error-flags.login',
		defaultMessage: 'Log in',
		description: 'Flag action button description. Indication login page action to clear the error.',
	},
});
